/**
 * Firestore kollekciónevek – egy helyen.
 *
 * A POD-adatok két kollekcióban élhetnek párhuzamosan:
 *   energy_pods     – a régi python_functions pipeline (measurements alkollekcióval, negyedóránként 1 dokumentum)
 *   energy_pods_v2  – az ei-pipeline (daily_summaries.values 96 elemű tömb, monthly/, mscons/, invoices/)
 *
 * Átkapcsolás: .env.local →  REACT_APP_POD_COLLECTION=energy_pods_v2   (majd újra build)
 */
export const POD_COLLECTION: string = process.env.REACT_APP_POD_COLLECTION || 'energy_pods';

/** Igaz, ha az ei-pipeline v2 szerkezetet használjuk (napi tömbök, nincs measurements alkollekció). */
export const POD_COLLECTION_IS_V2: boolean = POD_COLLECTION !== 'energy_pods';
